export default __webpack_public_path__ + "static/6766-3204c7c8129de34fd509ab5a63409b83.jpg";